export default "__VITE_PUBLIC_ASSET__2df45c76__"